import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import styles from "./image.module.css";

var ImageContainer = function ImageContainer(props) {
  var _classNames, _classNames2;

  var aspectRatioPercentage = props.aspectRatioPercentage,
      contentProp = props.content,
      sources = props.sources,
      expandToContent = props.expandToContent,
      hasAspectRatio = props.hasAspectRatio,
      loaded = props.loaded,
      lazy = props.lazy,
      overflow = props.overflow,
      offset = props.offset,
      children = props.children; // TODO: with the introduction of the new aspectRatio
  // prop in v2.7, consider renaming aspectRatioPercentage or
  // adding more documentation around its usage
  // during the react-image refactor (see https://nerdwallet.atlassian.net/browse/FEI-1158)

  var aspectRatioPercentageString = "".concat(aspectRatioPercentage, "%");
  var overrideAspectRatio = Boolean(sources.length > 1 || !aspectRatioPercentage);
  var content = contentProp && /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.children, (_classNames = {}, _defineProperty(_classNames, classes('position-absolute'), !expandToContent), _defineProperty(_classNames, classes('position-relative'), expandToContent), _classNames))
  }, contentProp);
  var reactLazyloadPlaceholder = /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['react-lazyload-placeholder'])
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, (_classNames2 = {}, _defineProperty(_classNames2, styles['aspect-ratio-content'], hasAspectRatio), _defineProperty(_classNames2, classes('position-relative'), !hasAspectRatio), _classNames2))
  }, !overrideAspectRatio && /*#__PURE__*/React.createElement("div", {
    className: styles.sizer,
    style: {
      paddingTop: aspectRatioPercentageString,
      // Using inline styles here due to conflict with reset CSS and widgets causing the margin to be set to 0.
      marginLeft: '-1px'
    }
  }), lazy ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.lazyload, _defineProperty({}, styles['lazyload--loaded'], loaded))
  }, /*#__PURE__*/React.createElement(LazyLoad, {
    once: true,
    overflow: overflow,
    offset: offset,
    placeholder: reactLazyloadPlaceholder
  }, children)) : children, content);
};

ImageContainer.displayName = 'ImageContainer';
ImageContainer.propTypes = {
  aspectRatioPercentage: PropTypes.number,
  children: PropTypes.node,
  content: PropTypes.node,
  expandToContent: PropTypes.bool,
  hasAspectRatio: PropTypes.bool,
  lazy: PropTypes.bool,
  loaded: PropTypes.bool,
  offset: PropTypes.number,
  overflow: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
  sources: PropTypes.array
};
export default ImageContainer;